import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';

export const AccordionFilters = () => {
  Alpine.data('AccordionFilters', () => ({
    tags: [],
    isSelected(tag) {
      return tag.some((x) => this.tags.includes(x));
    },
  }));
};
